import { isDefined } from "@clipboard-health/util-ts";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment } from "@mui/material";
import { TextInput } from "@src/appV2/redesign/components/TextInput";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type CredentialsFormData } from "../api/schema";
import { disabledInputTextSx } from "./shared";

interface AttendanceOnDemandTimeclockCredentialsProps {
  register: UseFormRegister<CredentialsFormData>;
  errors: FieldErrors<CredentialsFormData>;
  showPin?: boolean;
  onTogglePinVisibility: () => void;
  externalIdErrorPlaceholder?: string;
}

export function AttendanceOnDemandTimeclockCredentials({
  register,
  errors,
  showPin,
  onTogglePinVisibility,
  externalIdErrorPlaceholder,
}: AttendanceOnDemandTimeclockCredentialsProps) {
  return (
    <>
      <TextInput
        fullWidth
        label="AoD Person Number"
        InputLabelProps={{
          shrink: isDefined(externalIdErrorPlaceholder) ? true : undefined,
        }}
        // FIXME: Automatically disabled during ESLint config update
        error={Boolean(errors.externalId)}
        sx={isDefined(externalIdErrorPlaceholder) ? disabledInputTextSx : {}}
        helperText={errors.externalId?.message}
        disabled={isDefined(externalIdErrorPlaceholder)}
        placeholder={externalIdErrorPlaceholder}
        {...register("externalId")}
      />
      <TextInput
        fullWidth
        label="Time Clock PIN"
        type={showPin ? "text" : "password"}
        // FIXME: Automatically disabled during ESLint config update
        error={Boolean(errors.timeclockPin)}
        helperText={errors.timeclockPin?.message}
        inputProps={{ "data-dd-privacy": "mask" }}
        {...register("timeclockPin")}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                edge="end"
                onClick={onTogglePinVisibility}
              >
                {showPin ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <TextInput
        fullWidth
        label="Time Clock Badge"
        // FIXME: Automatically disabled during ESLint config update
        error={Boolean(errors.timeclockBadge)}
        helperText={errors.timeclockBadge?.message}
        {...register("timeclockBadge")}
      />
    </>
  );
}
